import React from 'react';
import { useTracking } from 'react-tracking';
import { Flex } from '@applatform/design-system';
import Feature from 'components/V1/Feature/Feature';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import { useIntl } from 'context/IntlContext/IntlContext';
import { v2Colors } from 'theme';
import Brand from './Brand/Brand';
import EnvironmentChip from './EnvironmentChip/EnvironmentChip';
import NavGroup from './NavGroup/NavGroup';
import NavLinkV2 from './NavLinkV2/NavLinkV2';
import navConfig, { NavItem } from './navConfig';

function SideNavV2() {
  const { Track } = useTracking({ module: 'SideNavV2' });
  const { environment } = useEnvironment();
  const { locale } = useIntl();

  function renderItem(item: NavItem) {
    if (item.environment && item.environment !== environment) {
      return null;
    }

    if (item.hiddenForGBR && locale === 'en-GB') {
      return null;
    }

    const link = (
      <NavLinkV2 key={item.to} to={item.to} icon={item.icon}>
        {item.label}
      </NavLinkV2>
    );

    return item.flag ? (
      <Feature key={item.to} flag={item.flag}>
        {link}
      </Feature>
    ) : (
      link
    );
  }

  return (
    <Track>
      <Flex
        as="aside"
        css={{
          flexDirection: 'column',
          height: '100%',
          backgroundColor: '$white',
          gap: '$4',
          borderRight: `1px solid ${v2Colors.line}`,
        }}
      >
        <Brand />
        <EnvironmentChip />
        <nav aria-label="Main Navigation">
          {navConfig.map((group) => (
            <NavGroup key={group.label ?? 'primary'} label={group.label}>
              {group.items.map(renderItem)}
            </NavGroup>
          ))}
        </nav>
      </Flex>
    </Track>
  );
}

export default SideNavV2;
